import { Button } from '@/components/ui/button'
import { IconPlus } from '@tabler/icons-react'
import { useDepartments } from '../context/departments-context'

export function DepartmentsPrimaryButtons() {
  const { setOpen } = useDepartments()
  return (
    <div className='flex gap-2'>
      <Button className='space-x-1' onClick={() => setOpen('create')}>
        <span>Novo departamento</span> <IconPlus size={18} />
      </Button>
    </div>
  )
}
